import { Stack, Text } from '@mantine/core'
import { useState } from 'react'

import classes from './CompanyLogo.module.css'

export const CompanyLogo = ({ domain, companyName }: { domain: string; companyName?: string }) => {
  const logoUrl = `https://${import.meta.env.VITE_LOGO_URL}/${domain}.png`
  const [showLogo, setShowLogo] = useState(true)

  return (
    <Stack justify='center' align='center' gap='0'>
      <img
        className={classes.image}
        src={logoUrl}
        alt={companyName}
        onLoad={() => setShowLogo(true)}
        style={{ display: showLogo ? 'block' : 'none' }}
        onError={(e) => {
          setShowLogo(false)
        }}
      />

      {companyName && (
        <Text
          ta='center'
          pt={logoUrl ? 2 : 0}
          size={logoUrl ? 'xs' : 'md'}
          className={classes.companyLogoText}
        >
          {companyName}
        </Text>
      )}
    </Stack>
  )
}
